import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=d8f95eba&scoped=true&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f95eba",
  null
  
)

export default component.exports